import {
    ProductConfigurableAttributesComponent as SourceProductConfigurableAttributesComponent,
} from 'SourceComponent/ProductConfigurableAttributes/ProductConfigurableAttributes.component';
import './ProductConfigurableAttributes.override.style';
import React from "react";
import FilterSwatchOptions from 'Component/FilterSwatchOptions';

export class ProductConfigurableAttributesComponent extends SourceProductConfigurableAttributesComponent {
    renderSwitch(option) {
        const { attribute_values = [], attribute_code } = option;
        const attributevalue = Object.values(option.attribute_options);
        const { handleOptionClick, isSelected, showProductAttributeAsLink, getLink, inStock, getIsConfigurableAttributeAvailable } = this.props;

        return (
            <FilterSwatchOptions
                attribute_code={attribute_code}
                attributevalue={attributevalue}
                option={option}
                renderConfigurableAttributeValue={this.renderConfigurableAttributeValue}
                attribute_values={attribute_values}
                handleOptionClick={handleOptionClick}
                isSelected={isSelected}
                showProductAttributeAsLink={showProductAttributeAsLink}
                getLink={getLink}
                inStock={inStock}
                getIsConfigurableAttributeAvailable={getIsConfigurableAttributeAvailable}
            />
        )
    }

    renderSwatch(option, isUnselected = false) {
        const {
            handleShakeAnimationEnd,
        } = this.props;

        const { attribute_code } = option;

        return (
            <div
                className={isUnselected ? 'ProductConfigurableAttributes-SwatchList ProductConfigurableAttributes-SwatchList_isUnselected' : 'ProductConfigurableAttributes-SwatchList'}
                key={attribute_code}
                onAnimationEnd={handleShakeAnimationEnd}
            >
                {this.renderSwitch(option)}
            </div>
        );
    }

    renderConfigurableAttributes() {
        const {
            configurable_options,
            isExpandable,
            inStock,
            handleShakeAnimationEnd,
            addToCartTriggeredWithError,
            parameters,
        } = this.props;

        return Object.values(configurable_options).map((option) => {
            const {
                attribute_code = '',
                attribute_label,
                attribute_options = {},
                attribute_id,
            } = option;
            const isUnselected = addToCartTriggeredWithError ? !parameters[attribute_code] : false;
            const [{ swatch_data }] = Object.values(attribute_options).length
                ? Object.values(attribute_options)
                : [{ swatch_data: undefined }];
            const isSwatch = !!swatch_data;

            if (!isExpandable) {
                return isSwatch ? this.renderSwatch(option) : this.renderDropdown(option);
            }

            if (!inStock && !isSwatch) {
                return null;
            }

            const selectedOption = parameters[attribute_code]?.toString();
            const selectedOptionLabel = selectedOption ? attribute_options[selectedOption]?.label : '';

            const isUnselected_classname = isUnselected ? "ProductConfigurableAttributes-Title_isUnselected" : "";

            return (
                <div key={attribute_id}>
                    <p
                        className={`ProductConfigurableAttributes-Title ${isUnselected_classname}`}
                        onAnimationEnd={handleShakeAnimationEnd}
                    >
                        {attribute_label}:
                        {isSwatch && (
                            <span className='ProductConfigurableAttributes-SelectedOptionLabel'>
                                {selectedOptionLabel}
                            </span>
                        )}
                    </p>
                    {isSwatch ? this.renderSwatch(option, isUnselected) : this.renderDropdown(option, isUnselected)}
                </div>
            );
        });
    }

    render() {
        const { isReady, mix } = this.props;

        return (
            <div
                className={(!isReady ? "ProductConfigurableAttributes_isLoading " : "") + `ProductConfigurableAttributes ${mix.block}-${mix.elem}`}
            >
                {/* {isReady ? this.renderConfigurableAttributes() : this.renderPlaceholders()} */}
                {this.renderConfigurableAttributes()}
            </div>
        );
    }
}

export default ProductConfigurableAttributesComponent;
